module.exports = __webpack_public_path__ + "static/img/lost-ethereal-pixel-art-low-res-retro-8bit-windmill.8451d6d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games/lost-ethereal/lost-ethereal-pixel-art-low-res-retro-8bit-windmill.gif
// module id = tFs0
// module chunks = 0